import { useMemo } from "react";
import {
  IMinerTypeOptionProps,
  IMinerTypeParamsOnly,
} from "./MinerTypeOption.props";
import { useIntl } from "react-intl";
import { getDevivedHash } from "@utils/hash.utils";
import cn from "classnames";
import { ALGOS_E } from "@constants/Algos";

import styles from "./MinerTypeOption.module.scss";

export default function MinerTypeOption({
  className,
  onlyParams,
  ...props
}: IMinerTypeOptionProps) {
  const { formatMessage } = useIntl();
  const additional = typeof props.meta === "string" ? JSON.parse(props.meta) : props.meta;

  const consumptionWithErr = useMemo(() => {
    if (!props.consumption || !additional.err) return 0;

    return Number(
      (props.consumption + (props.consumption * additional.err) / 100).toFixed(
        2
      )
    );
  }, [props.consumption, additional.err]);

  const params = (
    <span className={styles.params}>
      {!!props.performance && props.performance > 0 && (
        <span>
          {getDevivedHash(props.performance, { unit: props.algo as ALGOS_E })}
        </span>
      )}
      {consumptionWithErr > 0 && (
        <span>
          {consumptionWithErr} {formatMessage({ id: "calc.cons.bage" })}
        </span>
      )}
    </span>
  );

  if (onlyParams) {
    return params;
  }

  return (
    <div
      className={cn(styles.profile_item, className, {
        // [styles.sel]: isActiveSel,
      })}
      tabIndex={-1}
      title={props.name}
    >
      <span className={styles.name}>{props.name}</span>

      {params}
    </div>
  );
}

MinerTypeOption.Params = (props: IMinerTypeParamsOnly) => {
  return <MinerTypeOption {...props} onlyParams />;
};
